/**
 * Libraries & Packages
 */
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
window.axios = require('axios');
// import { some-component } from 'lodash';
// import { createPopper } from 'popper.js';

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';

/**
 * Custom Components
 */
import CareNavigatorForm from './components/careNavigatorForm';
import Navigation from './components/navigation';
import Logout from './components/logout';

/* jQuery on document ready */
$(function() {

  /**
   * Care Navigator Form
   */
  const careNavigatorForm = new CareNavigatorForm(
    this.card = $( '.block-care-navigator-cards .card' ),
    this.radio = $( 'input[type="radio"]' ),
  );
  careNavigatorForm.init();

  /**
   * Navigation
   */
  const navigation = new Navigation(
    this.nav = $( '.nav' ),
    this.navToggle = $( '.nav-toggle' ),
    this.navLink = $( '.nav-link' ),
    this.dropdown = $( '.dropdown' ),
    this.dropdownToggle = $( '.dropdown-toggle' ),
    this.dropdownMenu = $( '.dropdown-menu' ),
    this.dropdownItem = $( '.dropdown-item' ),
  );
  navigation.init();

  /**
   * Logout
   */
  const logout = new Logout(
    this.logoutButton = $( '.logout-button' ),
    this.logoutPopover = $( '.logout-popover' ),
  );
  logout.init();

});

/**
 * Vue
 */
import { createApp } from 'vue';
import ExampleComponent from './example-component/Main.vue';
import AlgoliaSearch from './algolia/Main.vue';
import PinnedPosts from './pinned-posts/Main.vue';

const app = createApp({
  components: {
    ExampleComponent,
    AlgoliaSearch,
    PinnedPosts,
  },
});

app.mount('#app');
